import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { initRouteTracking } from "./utils/analytics";

// Patch history once so every react-router navigation fires a page_view
// stamped with platform=web. The GTM container handles consent gating.
initRouteTracking();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
